var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepareGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3571 12.9217V25.5217H4.35717V5.52165H22.1714L25.3143 2.66455H1.5V28.3788H27.2143V10.2931L24.3571 12.9217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4557 1.62158L13.9558 15.7073L9.0986 10.8645L7.21289 12.7502L14.0844 19.6216L31.4986 3.6216L29.4557 1.62158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepareGray);
export default __webpack_public_path__ + "static/media/Prepare-Gray.f56bbdadb5c2eade7dc2bcca344e1bd5.svg";
export { ForwardRef as ReactComponent };